import { useEffect, useRef, useState } from 'react';
import requestClient from '../../Utility/RequestClient';
import ReactMarkdown from 'react-markdown';
import AdminContainer from '../../Utility/AdminContainer';

function Changelog() {
    // Hooks
    const requestClientRef = useRef(requestClient);

    // State
    const [changelog, setChangelog] = useState('');

    useEffect(() => {
        requestClientRef.current.get(`/settings/changelog`).then((response: any) => {
            setChangelog(response.data.changelog);
        });
    }, []);

    return (
        <div className={`admin-container flex relative flex-col`}>
            <AdminContainer>
                <div className="box">
                    <ReactMarkdown
                        components={{
                            a: (props) => {
                                return <span>{props.children}</span>;
                            },
                            h1: (props) => {
                                return <></>;
                            },
                            h2: (props) => {
                                return <h4>{props.children}</h4>;
                            },
                            h3: (props) => {
                                return <h6>{props.children}</h6>;
                            },
                        }}
                    >
                        {changelog}
                    </ReactMarkdown>
                </div>
            </AdminContainer>
        </div>
    );
}

export default Changelog;
